export class FormFactoryModel {
  group?: any[];
  controlType?:
    | 'input'
    | 'checkbox'
    | 'colorpicker'
    | 'datepicker'
    | 'input-password'
    | 'rich-editor'
    | 'dropdown'
    | 'multiselect'
    | 'chips'
    | 'page-seo'
    | 'textarea'
    | 'toggle'
    | 'media'
    | 'block-editor';
  colSize?: string; // Grid from primeng example: p-col-12
  dummyFields?: {
    options: {
      formControlName: string;
      formControlType?: 'array'; // Default is 'control'
      value?: any;
    };
  }[];
  roles?: number[] | undefined;
  options?: {
    // ? Universal options
    label?: string | false; // Label above field
    containerClass?: string; // This class is for input field container
    placeholder?: string; // Field placeholder
    formControlName?: string; // Form control name
    value?: any; // Default value for field
    disabled?: boolean; // Define is form field disabled
    validators?: {
      // Validators for form field
      required?: boolean;
      email?: boolean;
      maxLength?: number;
      pattern?: string;
      min?: number;
    };
    timeOnly?: boolean;
    errorMessage?: string;
    class?: string;
    // ? Input
    type?: string; // For input(text,number...) or media(image,video,pdf)
    // ? Dropdown
    dropdownOptions?: any;
    optionValue?: string;
    optionLabel?: string;
    closeOnChose?: boolean;
    multiple?: boolean;
    dateFormat?: string;
    maxDate?: any;
    id?: number;
    filter?: boolean;
    rows?: number | string;
    tooltip?: number | string;
    fieldFormGroup?: string;
    fullRow?: boolean; // Page seo in full row
    size?: 'big'; // bigger thumbnail for image
  };
}
